import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const getUniqueCode = async () => {
  try {
    const response = await mainAxios.get(
      `/v1/agente/unique-code`,
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};


export const getAgentesByRoles = async (roles) => {
  try {
    const response = await mainAxios.post(
      `/v1/agente/filter/roles`,
      roles,
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};